import Layout from "../Layout";
import {
    HeaderBox, HeaderDescription, HeaderTitle, PageBlock, PrimaryButton, PrimaryText, SecondaryText
} from "./../../features/Atoms"
import { Box, Grid, Link, Paper, Typography, Hidden, Container } from "@material-ui/core";
import coverImg from "./../../images/schools_bg.jpg";
import { useEffect, useState } from "react";
import IntroductionSection from './blocks/introduction';
import SchoolDescription from "./blocks/schoolDescription";
import ProgramInfo from "./blocks/programInfo";
import Testimonial from './../HomePage/Blocks/TestimonialBlock';
import FactsSection from "./blocks/factsSection";
import CoursesSection from "./blocks/courses";
import First_pane from "./blocks/first_pane";
import SearchSchools from './blocks/search_school';
import CoursesPark from './blocks/courses_prk_rec';
import ContactModal from './../../features/ContactModal';
import { TabularSchoolList } from './../SchoolListingPage/schoolListingPage';
import Teachers from './../HomePage/Blocks/AmazingTeachersBlock'


export default () => {
    
    
    return (
        <Layout>
            <First_pane />
            <IntroductionSection />
            <CoursesSection />
            <SchoolDescription />
              {/* <CoursesSection />  */}
            <ProgramInfo />
            <div className="uk-margin-large-top"><Teachers /> </div>
         <div className="CourseSearchArea">   <SearchSchools /> </div>
            <Container style={{ marginTop: 30 }}>
                <Grid container direction="row" alignItems="center" justifyContent="center">
                    <Grid item xs={8} style={{margin: '20px 0', marginTop: '10vh'}}>
                        <h3 className= "header3" style={{textAlign: 'center'}}>Our Customer List</h3>
                    </Grid>
                </Grid>
                <TabularSchoolList />
            </Container>
            <PageBlock>
                <Box id="map"></Box>
            </PageBlock>
           <div className="uk-margin-large-top"> <Testimonial /> </div>
            
            <FactsSection />
            <CoursesPark />

          
            
        

           
           
        </Layout>
    )
}